"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _formik = require("formik");
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _Done = _interopRequireDefault(require("../../../../icons-react/Done"));
var _styled = require("../styled");
var _InputHeader = _interopRequireDefault(require("../InputHeader"));
var _InputError = _interopRequireDefault(require("../InputError"));
var _PostfixIconWrapper = _interopRequireDefault(require("../PostfixIconWrapper"));
var _InputHint = _interopRequireDefault(require("../InputHint"));
var _excluded = ["className", "name", "placeholder", "nativeInputProps", "header", "prependIcon", "postfixIcon", "postfixIconProps", "mask", "isMobile", "hint", "onChange", "variant", "renderAppendAddon", "height", "type", "onBlur", "withoutSuccessIcon"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Input = function Input(props) {
  var className = props.className,
    name = props.name,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$nativeInputPro = props.nativeInputProps,
    nativeInputProps = _props$nativeInputPro === void 0 ? {} : _props$nativeInputPro,
    _props$header = props.header,
    header = _props$header === void 0 ? '' : _props$header,
    prependIcon = props.prependIcon,
    postfixIcon = props.postfixIcon,
    postfixIconProps = props.postfixIconProps,
    mask = props.mask,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    hint = props.hint,
    onChange = props.onChange,
    variant = props.variant,
    renderAppendAddon = props.renderAppendAddon,
    height = props.height,
    type = props.type,
    _onBlur = props.onBlur,
    withoutSuccessIcon = props.withoutSuccessIcon,
    formikRest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useField = (0, _formik.useField)(_objectSpread({
      name: name
    }, formikRest)),
    _useField2 = (0, _slicedToArray2["default"])(_useField, 1),
    field = _useField2[0];
  var onChangeFormik = field.onChange,
    onBlurFormik = field.onBlur;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext.setFieldValue,
    errors = _useFormikContext.errors,
    touched = _useFormikContext.touched;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    focus = _React$useState2[0],
    setFocus = _React$useState2[1];
  var onChangeHandler = function onChangeHandler(e) {
    onChangeFormik(e.target.value);
    onChange === null || onChange === void 0 || onChange(e.target.value);
    setFieldValue(name, e.target.value);
  };
  var hasError = Boolean(errors[name] && touched[name]);
  var styledProps = {
    hasError: hasError && !focus,
    hasTouched: Boolean(touched[name]),
    height: height
  };
  var inputProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, field), nativeInputProps), styledProps), {}, {
    id: name,
    name: name,
    placeholder: placeholder,
    variant: variant,
    onChange: onChangeHandler,
    onBlur: function onBlur(e) {
      setFocus(false);
      if (_onBlur) _onBlur(e);
      onBlurFormik(e);
    },
    onFocus: function onFocus() {
      return setFocus(true);
    },
    type: type
  });
  var input = (0, _isNil["default"])(mask) ? /*#__PURE__*/_react["default"].createElement(StyledInput, inputProps) : /*#__PURE__*/_react["default"].createElement(StyledMaskedInput, (0, _extends2["default"])({}, inputProps, {
    mask: mask,
    maskChar: null,
    value: field.value
  }));
  var isCompleted = Boolean(!errors[name]) && Boolean(touched[name]) && Boolean(field.value);
  var isShowSuccessIcon = (!(0, _isNil["default"])(postfixIcon) || !focus && isCompleted) && !withoutSuccessIcon;
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledInputContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_InputHeader["default"], {
    text: header,
    prependIcon: prependIcon,
    isMobile: isMobile
  }), /*#__PURE__*/_react["default"].createElement(StyledInputWrapper, styledProps, input, isShowSuccessIcon && /*#__PURE__*/_react["default"].createElement(_PostfixIconWrapper["default"], postfixIconProps, (0, _isNil["default"])(postfixIcon) ? /*#__PURE__*/_react["default"].createElement(DoneStyled, null) : postfixIcon)), /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    name: name,
    renderAppendAddon: renderAppendAddon
  }), !(0, _isNil["default"])(hint) && !hasError && /*#__PURE__*/_react["default"].createElement(_InputHint["default"], null, hint));
};
var StyledInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Input__StyledInputWrapper",
  componentId: "sc-y68z5a-0"
})(["position:relative;display:flex;flex-direction:row;align-items:center;overflow:hidden;", " ", ";", ";", ""], _styled.InputStyles.Normal, function (_ref) {
  var disabled = _ref.disabled;
  return disabled && _styled.InputStyles.Disabled;
}, function (_ref2) {
  var hasError = _ref2.hasError;
  return hasError && _styled.InputStyles.Error;
}, function (_ref3) {
  var height = _ref3.height;
  return height && "height: ".concat(height, "px");
});
var StyledInputCSS = (0, _styledComponents.css)(["", " width:100%;::placeholder{", "}:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px white inset !important;}:focus{", "}", ""], _styled.InputStyles.Base, _styled.InputStyles.Placeholder, _styled.InputStyles.Focus, function (_ref4) {
  var variant = _ref4.variant;
  return variant === 'small' && _styled.InputStyles.Small;
});
var StyledMaskedInput = (0, _styledComponents["default"])(_reactInputMask["default"]).withConfig({
  displayName: "Input__StyledMaskedInput",
  componentId: "sc-y68z5a-1"
})(["", ""], StyledInputCSS);
var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-y68z5a-2"
})(["", ""], StyledInputCSS);
var DoneStyled = (0, _styledComponents["default"])(_Done["default"]).withConfig({
  displayName: "Input__DoneStyled",
  componentId: "sc-y68z5a-3"
})(["height:16px;width:16px;path{stroke:#459e18;}"]);
var _default = exports["default"] = Input;